import { compareValues } from "@sscs/utils";
export const compareIssueOverrides = (first, second) => {
    if (first.status === second.status) {
        return first.enabled ? -1 : 1;
    }
    else {
        return compareValues(first.status, second.status, false);
    }
};
export const compareGrade = (firstGrade, secondGrade, firstStatus, secondStatus, firstIssueCount, secondIssueCount, reverse) => {
    if (firstGrade.toLowerCase() < secondGrade.toLowerCase())
        return reverse ? 1 : -1;
    else if (firstGrade.toLowerCase() > secondGrade.toLowerCase())
        return reverse ? -1 : 1;
    else if (firstStatus === "pass" && secondStatus === "fail")
        return reverse ? 1 : -1;
    else if (firstStatus === "fail" && secondStatus === "pass")
        return reverse ? -1 : 1;
    else
        return compareValues(firstIssueCount, secondIssueCount, reverse);
};
export const generateOverrideId = (override) => {
    return `${override.status}-${override.enabled}`;
};
//# sourceMappingURL=issues.js.map